import React, { FC, useRef } from 'react';
import { collectionMeta } from '@prisma/client';
import { getToysSortQuery, PageQueries } from '@specs/navigation';
import { useRouter } from 'next/router';
import { useGetPublicToysInfinity } from '@hooks/TRPC_Hooks/useGetToys';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { BonusToyCard } from '@components/Cards/BonusToyCard/BonusToyCard';
import s from './list.module.scss';
interface Props {
  collection: collectionMeta;
  id: number;
}
const limit = 7;
export const CollectionToysPublicList: FC<Props> = ({
  id
}) => {
  const router = useRouter();
  const {
    toysSort,
    query,
    priceSortCurrency,
    toysRarity
  }: PageQueries = router.query;
  const enabledRef = useRef(false);
  const sort = getToysSortQuery(toysSort);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status
  } = useGetPublicToysInfinity({
    limit,
    sort,
    query,
    rarity: toysRarity,
    currency: priceSortCurrency,
    collection: id
  }, {
    enabled: enabledRef.current
  });
  return <>
            <InfinityList data={data} staticItemBeforeList={<BonusToyCard collectionId={id} className={s.list__bonusToy} />} fetchNextPage={fetchNextPage} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} status={status} enabledRef={enabledRef} listClassName={'_toysGrid'} data-sentry-element="InfinityList" data-sentry-source-file="CollectionToysPublicList.tsx">
                {item => {
        return <ToyCard key={item.id} {...item} />;
      }}
            </InfinityList>
        </>;
};